<template>
  <div class="user-container">
    <div class="table-field-total">
      <el-row class>
        <label style="margin-right: 30px;">付款方名称:</label>
        <el-input style="width:200px;" v-model="params.consName" placeholder="请输入付款方名称"></el-input>
        <label style="margin: 0 30px;">付款方手机:</label>
        <el-input style="width:200px;" v-model="params.mobile" placeholder="请输入付款方手机"></el-input>
        <label style="margin: 0 30px;">商户订单号:</label>
        <el-input style="width:200px;" v-model="params.transId" placeholder="请输入商户订单号"></el-input>
      </el-row>

      <el-row>
        <label style="margin-right: 30px;">开始日期:</label>
        <el-date-picker
          v-model="params.startTime"
          align="right"
          type="date"
          placeholder="选择开始日期"
          style="width:150px;"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <label style="margin:0 30px;">结束日期:</label>
        <el-date-picker
          v-model="params.endTime"
          align="right"
          type="date"
          placeholder="选择结束日期"
          style="width:150px;"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <label style="margin:0 30px;">支付状态:</label>
        <el-select v-model="params.status" placeholder="请选择">
          <el-option label="全部" value></el-option>
          <el-option label="成功" value="2"></el-option>
          <el-option label="未支付" value="1"></el-option>
        </el-select>
        <el-button style="margin:0 30px;" type="primary" @click="handleSearch">搜索</el-button>
        <el-button type="info" @click="handleExportOrderDetailExecl">导出</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
      show-summary
      :summary-method="handleTotal"
    >
      <el-table-column prop="consName" label="付款方名称"></el-table-column>
      <el-table-column prop="consMobile" label="付款方电话"></el-table-column>
      <el-table-column prop="body" label="收费类目" width="180"></el-table-column>
      <el-table-column prop="totalFee" label="收款金额"></el-table-column>
      <el-table-column prop="fee" label="手续费"></el-table-column>
      <el-table-column prop="createTime" label="下单时间" width="180"></el-table-column>
      <el-table-column prop="transactionId" label="商户订单号" width="280"></el-table-column>
      <el-table-column prop="payTime" label="支付时间" width="180"></el-table-column>
      <el-table-column prop="userName" label="收费员" width="180"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="danger">未支付</el-tag>
          <el-tag v-if="scope.row.status === 2" type="success">已支付</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="params.limit"
      :current-page="params.page"
      style="margin-top:30px;"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="handleClickPage"
    ></el-pagination>
  </div>
</template>

<script>
import { orderList } from "@/axios/api";
import { exportOrderDetailExecl } from "@/axios/excel-api";
export default {
  data() {
    return {
      tableData: [{}],
      params: {
        page: 1,
        limit: 30,
        consName: "",
        startTime: new Date(),
        endTime: new Date(),
        mobile: "",
        status: "",
        transId: ""
      },
      total: 0,
      totalize: {}
    };
  },
  methods: {
    handleExportOrderDetailExecl() {
      exportOrderDetailExecl(this.params).then(res => {
        var blob = new Blob([res], {
          type: "application/octet-stream;charset=utf-8"
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "ALL_" + this.params.beginTime + "_" + this.params.endTime + ".xls"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href);
      });
    },
    handleSearch() {
      this.params.page = 1;
      this.handleOrderList();
    },
    handleOrderList() {
      orderList(this.params).then(res => {
        this.tableData = res.records;
        this.total = res.total;
        this.totalize = res.totalize;
      });
    },
    handleClickPage(event) {
      this.params.page = event;
      this.handleOrderList();
    },
    handleTotal($event) {
      const { columns, data } = $event;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计:" + this.totalize.totalFeeTimes + "笔";
          return;
        }
        switch (column.property) {
          case "totalFee":
            sums[index] = this.totalize.totalFee + '元';
            break;
          case "fee":
            sums[index] = this.totalize.fee + '元';
            break;
          default:
            break;
        }
      });
      return sums;
    }
  },
  mounted() {
    this.handleOrderList();
  }
};
</script>

<style scoped>
.table-field-total .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field-total {
  width: 100%;
  height: 180px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
  padding: 30px;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/order/OrderList.vue